import { render, staticRenderFns } from "./RoomSelectView.vue?vue&type=template&id=2a012058&scoped=true&"
import script from "./RoomSelectView.vue?vue&type=script&lang=js&"
export * from "./RoomSelectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a012058",
  null
  
)

export default component.exports